import { render } from "./DjFreezeTab.vue?vue&type=template&id=3b3dc4c0&scoped=true"
import script from "./DjFreezeTab.vue?vue&type=script&lang=js"
export * from "./DjFreezeTab.vue?vue&type=script&lang=js"

import "./DjFreezeTab.vue?vue&type=style&index=0&id=3b3dc4c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b3dc4c0"

export default script